import { Box } from "@mui/material"
import type { FC } from "react"

import { StatusIndicator } from "@/components/common/StatusIndicator/StatusIndicator"
import { ComputedProductStatusMap } from "@/screens/Companies/products/utils/productStatusMap"
import TableCellWithId from "@/screens/ManageProducts/components/Instructions/components/tables/TableCellWithId"

interface ProductIdCellProps {
  externalSystemId?: string | null
  publicId?: string | null
  computedProductStatus?: string | null
}

export const ProductIdCell: FC<ProductIdCellProps> = ({ externalSystemId, publicId, computedProductStatus }) => {
  return (
    <div className='flex items-center gap-2'>
      <Box className='mx-2'>
        <StatusIndicator
          data-testid={`statusIndicator-${computedProductStatus}`}
          status={computedProductStatus as string}
          map={ComputedProductStatusMap}
        />
      </Box>
      <TableCellWithId id={externalSystemId}>{publicId}</TableCellWithId>
    </div>
  )
}
